<template>
  <div v-if="categories">
    <q-item
      v-for="category in categories"
      :key="category.id"
      clickable
      class="q-py-md"
      :to="`/category/${category.id}`"
    >
      <q-item-section
        avatar
        class="row items-center full-width"
        :class="{
          'items-end': $q.screen.width < 1440,
          'items-center': $q.screen.width >= 1440,
        }"
      >
        <span class="navTitle text-uppercase">{{ translateTitle(category) }}</span>
      </q-item-section>
    </q-item>
    <q-item
      clickable
      class="q-py-md"
      :to="{ name: 'Catering' }"
    >
      <q-item-section
        avatar
        class="row text-h6 items-center full-width"
        :class="{
          'items-end': $q.platform.is.desktop,
          'items-center': $q.platform.is.mobile,
        }"
      >
        <span class="navTitle text-uppercase">
          {{ translateTitle(cateringCategory) }}
        </span>
      </q-item-section>
    </q-item>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';
import CategoryModel from 'quasar-pilot-core/src/lib/models/category';
import languageMixin from 'quasar-pilot-core/src/mixins/util/language';
import constants from 'src/lib/constants';

export default {
  name: 'LayoutNav',
  mixins: [languageMixin],

  data() {
    return {
      categories: [],
      cateringCategory: null,
    };
  },

  computed: {
    ...mapState('location', { currentLocation: 'current' }),
    ...mapGetters('category', ['findCategory']),
    ...mapGetters('location', ['findLocation']),
  },

  watch: {
    currentLocation() {
      this.updateNavigation();
    },
  },

  created() {
    this.updateNavigation();

    if (constants.DEFAULT_CATERING_LOCATION) {
      const location = this.findLocation(constants.DEFAULT_CATERING_LOCATION);
      if (location.categoryId) {
        const category = this.findCategory(location.categoryId);
        if (category) {
          this.cateringCategory = new CategoryModel(category);
        }
      }
    }
  },

  methods: {
    updateNavigation() {
      this.categories = [];
      const rootCategory = this.findCategory(this.currentLocation.categoryId);
      if (rootCategory?.children?.length) {
        rootCategory.children.forEach((child) => {
          const category = this.findCategory(child.id);
          if (category) {
            this.categories.push(new CategoryModel(category));
          }
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.navTitle {
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 16px;
  padding-top: 10px;
  @media (max-width: 1439px) {
    font-weight: 400;
    font-size: 22px;
  }
}
.navIcon {
  height: 30px;
  margin-bottom: 5px;
  outline: 0;
}
.q-item--clickable {
  color: $accent;
}
.q-router-link--active {
  color: $secondary!important;
}
.q-item__section--side {
  padding-right: 8px!important;
  padding-left: 8px;
}
</style>
